<template>
  <div class="document clearfix">
    <!-- 侧边栏 -->
    <h-page-container>
      <!-- <h-page-header slot="pageHeader" :breadcrumb="breadcrumb" /> -->
      <h-layout>
        <h-page-sidebar>
          <el-tree
            ref="areaTree"
            :data="treeData"
            :props="defaultProps"
            node-key="id"
            @node-click="handleNodeClick"
            :current-node-key="currentTreeId"
            :default-expanded-keys="expandedTree"
          />
        </h-page-sidebar>
        <div class="showAnchor">
     <div class="header-right">
      </div>
          <div v-if="isApiPage">
            <h-anchor :offset-top="60" show-ink :affix='false' :scroll-offset="60" height="600">
              <div v-for="(apia, index) in apis" :key="index">
                  <h-anchor-link :href="apia.hrefId" :title="apia.name" style="width:170px" />
              </div>
            </h-anchor>
          </div>
          <div v-else>
            <h-anchor :offset-top="60" show-ink :affix='false' :scroll-offset="80" >
              <div v-for="(doc, i) in docList" :key="i">
                  <h-anchor-link :href="doc.hrefId" :title="doc.title" style="width:170px"/>
              </div>
            </h-anchor>
          </div>
        </div>
        <div class="markdown-wrapper equal-height middleCon">
          <div class="detailContent">
            <div v-if="!isApiPage" class="markdown-body editormd-html-preview" style="padding-top:10px;">
              <div v-if="map.title">
                <h1 v-text="map.title" class="font24"></h1>
                <div v-html="map.html" @click="apiJ" class="font14"></div>
              </div>
              <div v-else>
                <div class="no-data"></div>
                <div class="txt">{{$t('h.common.noData')}}

                </div>
              </div>
            </div>
            <div v-if="isApiPage" class="apiPage">

              <div v-if="path">
                <h1 style="width:80%" class="font24">{{path[path.length-1]['title']}}</h1>

              </div>
              <div v-if="apis.length > 0">
                      <div v-html="groupDescription"  @click="apiJ" style="width: 85%;"></div>
                <div class="downbt">
                      <el-button type="primary" class="javaDownBt" :loading="docDownloading">
                          <a class="btn downloadfile" @click="getAllApiDoc()">{{$t('document.docDown')}}</a>
                  </el-button>
                        <el-button type="primary" class="javaDownBt" :loading="sdkDownloading">
                    <!-- <a v-if='sdkId' :href="`/artemis-portal/artemis/getSdkByApiGroupPId?id=${sdkId}`" class="btn download">{{$t('document.javeDown')}}</a> -->
                          <a v-if='sdkId' @click="getSdkByApiGroupPId(`${sdkId}`)" class="btn download">{{$t('document.javeDown')}}</a>
                  </el-button>
                        <el-button type="primary" class="javaDownBt" :loading="downloading">
                    <!-- <a v-if='sdkId' :href="`/artemis-portal/artemis/getApiGroupDoc/${sdkId}`" class="btn downloadfile">{{$t('document.groupDown')}}</a> -->
                          <a v-if='sdkId' class="btn downloadfile" @click="getApiGroupDoc(`${sdkId}`)">{{$t('document.groupDown')}}</a>
                  </el-button>
                </div>
                      <p style="margin-top:10px;font-weight:bold;" class="font14">{{$t('document.ShowApiList')}}</p>
                <div class="table-margin">
                  <template>
                    <el-table
                      ref="apiTable"
                      :data="apis"
                      stripe
                            style="width: 99%">
                            <el-table-column
                              type="index"
                              width="30">
                      </el-table-column>
                      <el-table-column
                        prop="name"
                              :label="$t('document.ApiName')">
                        <template slot-scope="scope">
                          <a :href="scope.row.hrefId">{{ scope.row.name }}</a>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="description"
                              :label="$t('document.description')" min-width="200">
                        <template slot-scope="scope">
                                <div v-html="scope.row.description" @click="apiJ"></div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="id"
                              :label="$t('document.sdkDown')">
                        <template slot-scope="scope">
                                <a :href="`/artemis-portal/artemis/getSdkByApiId?id=${scope.row.id}`">{{$t('document.sdkDown')}}</a>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="id"
                              :label="$t('document.apiDown')">
                        <template slot-scope="scope">
                                <a :href="`/artemis-portal/artemis/getApiDocxById/${scope.row.id}`">{{$t('document.apiDown')}}</a>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="minVersion"
                              :label="$t('document.versionSuptStart')">
                      </el-table-column>
                      <el-table-column
                        prop="maxVersion"
                              :label="$t('document.versionSuptEnd')">
                      </el-table-column>
                    </el-table>
                  </template>
                </div>
                      <hr id="api1">
                <div v-for="(api, index) in apis" :key="index">
                  <h2 style="margin-top: 20px" :id="api.id">
                          <a :href="api.herfName" aria-hidden="true" class="header-anchor" style="display: none">#</a>
                    {{ index + 1 }}.{{ api.name }}
                  </h2>
                  <ul>
                    <li>
                      <div class="baseTitleStyle">
                              <h3 style="margin-left:5px">{{$t('document.basicInfo')}}</h3>
                      </div>
                      <!-- <p>{{$t('document.nameC')}}{{api.name}}</p> -->
                      <div>
                              <div class="baseLineTitleStyle">{{$t('document.descriptionNew')}}</div>
                              <p class="baseLineStyle" v-html="api.description" @click="apiJ"></p>
                      </div>
                      <div>
                              <div class="baseLineTitleStyle">{{$t('document.groupC')}}</div>
                              <p class="baseLineStyle" v-html="api.group.name" @click="apiJ"></p>
                      </div>
                      <div>
                              <div class="baseLineTitleStyle">{{$t('document.versionSuptC')}}</div>
                              <p class="baseLineStyle" v-html="api.minVersion" @click="apiJ"></p>
                      </div>
                      <!-- <p>{{$t('document.groupC')}}{{api.group.name}}</p>
                            <p>{{$t('document.versionSuptC')}}{{api.minVersion}}</p> -->
                    </li>
                    <li>
                      <div class="baseTitleStyle">
                              <h3 style="margin-left:5px">{{$t('document.BaseicRequest')}}</h3>
                      </div>
                      <div>
                              <div class="baseLineTitleStyle">{{$t('document.protocolC')}}</div>
                        <p class="baseLineStyle">{{ api.protocol }}</p>
                      </div>
                      <div>
                              <div class="baseLineTitleStyle">{{$t('document.hostPath')}}</div>
                              <p class="baseLineStyle">{{hostPath}}{{api.path}}</p>
                      </div>
                      <div>
                        <div class="baseLineTitleStyle">HTTP METHOD：</div>
                        <p class="baseLineStyle">{{ api.httpMethod }}</p>
                      </div>
                      <div>
                              <div class="baseLineTitleStyle" >{{$t('document.securityVerificationC')}}</div>
                              <p class="baseLineStyle" v-if="api.authenticationMode == '0'">{{$t('document.freeCertification')}}</p>
                              <p class="baseLineStyle" v-else-if="api.authenticationMode == '1'">{{$t('document.aksk')}}</p>
                              <p class="baseLineStyle" v-else-if="api.authenticationMode == '2'">{{$t('document.oauth2')}}</p>
                      </div>
                      <!-- <h4>{{$t('document.BaseicRequest')}}</h4> -->
                      <!-- <p>{{$t('document.protocolC')}}{{api.protocol}}</p>
                            <p>{{$t('document.requestPathC')}}{{api.path}}</p>
                            <p>{{$t('document.hostPath')}}{{hostPath}}{{api.path}}</p>
                            <p>HTTP METHOD：{{api.httpMethod}}</p>
                            <p>{{$t('document.securityVerificationC')}}{{$t('document.APIGatewaySV')}}</p> -->
                    </li>
                    <li>
                      <div class="baseTitleStyle">
                              <h3 style="margin-left:5px">{{$t('document.requestDefinition')}}</h3>
                      </div>
                      <!-- <h4>{{$t('document.requestDefinition')}}</h4> -->
                            <div v-if="api.inputParams.length" class="tableScroll" style=" margin-left:20px;margin-top:10px">
                        <div class="table-margin">
                          <template>
                            <el-table
                              ref="oneapi"
                              :data="api.inputParams"
                              stripe
                                    style="width: 99%">
                              <el-table-column
                                      type="index">
                                    </el-table-column>
                                    <el-table-column prop="model.name" :label="$t('document.paramName')">
                                <template slot-scope="scope">
                                          <span :style="{ marginLeft:scope.row._level * 30 + 'px' }">{{scope.row.name}}</span>
                                </template>
                              </el-table-column>
                                    <el-table-column prop="position" :label="$t('document.paramLocation')">
                              </el-table-column>
                                    <el-table-column prop="model.type" :label="$t('document.type')">
                              </el-table-column>
                                    <el-table-column prop="model.required" :label="$t('document.required')">
                                <template slot-scope="scope">
                                            <i :class="[scope.row.required ? 'h-icon-tip_right' : 'h-icon-tip_error']" style="font-size: 22px;"></i>
                                </template>
                              </el-table-column>
                              <el-table-column
                                prop="model.description"
                                      :label="$t('document.description')">
                                <template slot-scope="scope">
                                        <div v-html="scope.row.description" @click="apiJ"></div>
                                </template>
                              </el-table-column>
                                    <el-table-column prop="example" :label="$t('document.examples')"></el-table-column>
                            </el-table>
                          </template>
                        </div>
                      </div>
                            <p class="baseLineTitleStyle" v-else>{{$t('document.null')}}</p>
                    </li>
                    <li v-if="api.inBody">
                      <div class="baseTitleStyle">
                              <h3 style="margin-left:5px">{{$t('document.requestBodyDefin')}}</h3>
                      </div>
                      <div>
                              <div class="baseLineTitleStyle" >contentType：</div>
                              <p class="baseLineStyle">{{ api.inBody.contentType }}</p>
                      </div>
                      <div>
                              <div class="baseLineTitleStyle" >{{$t('document.descriptionC')}}</div>
                      </div>
                      <!-- <h4>{{$t('document.requestBodyDefin')}}</h4> -->
                      <!-- <p>{{$t('document.typeC')}}{{api.inBody.contentType}}</p>
                            <p>{{$t('document.descriptionC')}}</p> -->
                            <div class="table-margin" style="margin-left:20px;margin-top:10px">
                        <template>
                          <el-table
                            ref="oneapiinbody"
                            :data="api.inBody.children"
                            stripe
                                    style="width: 99%">
                            <el-table-column
                                      type="index">
                                    </el-table-column>
                                    <el-table-column prop="name" :label="$t('document.fieldName')">
                              <template slot-scope="scope">
                                <!-- <span v-if='scope.row.mappingName' :style="{ marginLeft:scope.row._level * 30 + 'px' }">{{scope.row.mappingName}}</span> -->
                                          <span :style="{ marginLeft:scope.row._level * 30 + 'px' }">{{scope.row.name}}</span>
                              </template>
                            </el-table-column>
                                    <el-table-column prop="type" :label="$t('document.type')">
                            </el-table-column>
                                    <el-table-column prop="model.required" :label="$t('document.required')">
                              <template slot-scope="scope">
                                            <i :class="[scope.row.required ? 'h-icon-tip_right' : 'h-icon-tip_error']" style="font-size: 22px;"></i>
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="description"
                                      :label="$t('document.description')" min-width="160">
                              <template slot-scope="scope">
                                        <div v-html="scope.row.description" @click="apiJ"></div>
                              </template>
                            </el-table-column>
                                    <el-table-column prop="example" :label="$t('document.examples')"></el-table-column>
                          </el-table>
                        </template>
                      </div>
                            <p class="baseLineTitleStyle">{{$t('document.examplesC')}}</p>
                            <div class="example-container" :title="api.inBody.demo" style="margin-left:20px;margin-right:10px">
                        <pre class="json-pre">{{ api.inBody.demo }}</pre>
                      </div>
                      <!-- <p>{{$t('document.examplesC')}}</p> -->
                      <!-- <div class="example-container" :title="api.inBody.demo">
                              <pre class="json-pre">{{api.inBody.demo}}</pre>
                            </div> -->
                    </li>
                    <li>
                      <div class="baseTitleStyle">
                              <h3 style="margin-left:5px">{{$t('document.responseResult')}}</h3>
                      </div>
                      <div>
                              <div class="baseLineTitleStyle" >{{$t('document.responseTypeC')}}</div>
                              <p class="baseLineStyle"><span data-parse="result-type">{{api.response.contentType}}</span></p>
                      </div>
                      <div>
                              <div class="baseLineTitleStyle" >{{$t('document.responseDesC')}}</div>
                      </div>
                      <!-- <h4>{{$t('document.responseResult')}}</h4>
                            <p>{{$t('document.responseTypeC')}}<span data-parse="result-type">{{api.response.contentType}}</span></p>
                            <p>{{$t('document.responseDesC')}}</p> -->
                            <div class="table-margin" style="margin-left:20px;margin-top:10px">
                        <template>
                          <el-table
                            ref="oneapirespon"
                            :data="api.response.children"
                            stripe
                                    style="width: 99%">
                                    <el-table-column
                                      type="index"
                                      width="30">
                            </el-table-column>
                                    <el-table-column prop="mappingName" :label="$t('document.fieldName')">
                              <template slot-scope="scope">
                                          <span v-if='scope.row.mappingName' :style="{ marginLeft:scope.row._level * 30 + 'px' }">{{scope.row.mappingName}}</span>
                                          <span v-else :style="{ marginLeft:scope.row._level * 30 + 'px' }">{{scope.row.name}}</span>
                              </template>
                            </el-table-column>
                                    <el-table-column prop="type" :label="$t('document.type')">
                            </el-table-column>
                                    <el-table-column prop="required" :label="$t('document.required')">
                              <template slot-scope="scope">
                                          <i :class="[scope.row.required ? 'h-icon-tip_right' : 'h-icon-tip_error']" style="font-size: 22px;"></i>
                              </template>
                            </el-table-column>
                                    <el-table-column prop="description" :label="$t('document.description')">
                              <template slot-scope="scope">
                                        <div v-html="scope.row.description" @click="apiJ"></div>
                              </template>
                            </el-table-column>
                                    <el-table-column prop="example" :label="$t('document.examples')"></el-table-column>
                          </el-table>
                        </template>
                      </div>
                      <div>
                              <div class="baseLineTitleStyle" >{{$t('document.responseExampleC')}}</div>
                        </div>
                            <div class="tableScroll example-container" :title="api.response.resDemo" style="margin-left:20px;margin-right:10px">
                        <pre class="json-pre">{{ api.response.example }}</pre>
                      </div>
                      <!-- <p>{{$t('document.responseExampleC')}}</p>
                            <div class="tableScroll example-container" :title="api.response.resDemo">
                              <pre class="json-pre">{{api.response.example}}</pre>
                            </div> -->

                    </li>
                    <li>
                      <div class="baseTitleStyle">
                                <h3 style="margin-left:5px">{{$t('document.onlineDebug')}}</h3>
                      </div>
                      <p class="btn-p">
                                <el-button :plain="true" class="debug-online-btn noline" target="_blank" type="primary" @click="jumpToWeb(`/artemis-web/debug/${api.id}`)">{{$t('document.DebugIng')}}</el-button>
                      </p>
                      <!-- <h4>{{$t('document.onlineDebug')}}</h4>
                            <p class="btn-p">
                             <el-button :plain="true" class="debug-online-btn noline" type="primary"  @click="jumpToWeb(`/artemis-web/debug/${api.id}`)">{{$t('document.DebugIng')}}</el-button>
                            </p> -->
                    </li>
                  </ul>
                        <hr :id="`api${index+2}`">
                </div>
              </div>
            </div>
          </div>
        </div>
      </h-layout>
    </h-page-container>

  </div>
</template>
<script>
// import HelloWord from '@/components/HelloWorld.vue'
import { getTree, getDocById, getApiByGroupId, getDocByName, getDocByGroupId, getApiHost, getGroup, getApiGroupDoc, getSdkByApiGroup, getAllApiDoc, getProductIdAndVersion, getProjectInfo } from "@/api";
import tableData from "@/components/tableData/tableData";
import { errorCodeKey } from '@/api/errorCode.js';
import { downloadFile } from '@/api/download.js';

export default {
  name: 'Document',

  data() {
    return {
      downloading: false,
      docDownloading: false,
      sdkDownloading: false,
      currentTreeId: 0,
      showInitTreeId: 0,
      expandedTree: ['0'],
      docId: '',
      breadcrumb: ['Title', 'Title', 'Title', 'Title'],
      treeData: [],
      docList: [],
      isApiPage: false,
      groupDescription: '',
      sdkId: '',
      hostPath: '',
      defaultProps: {
        children: 'children',
        label: 'title',
      },
      path: [
        {
          id: '',
          title: ''
        }
      ],
      map: {
        title: '',
        html: ''
      },
      apis: [],

    }
  },
  async created() {
    const param = {
      "id": "0"
    }
    const { data } = await getTree(param);
    let tData = this.showTree(data.data.children);
    this.treeData = tData;
  },
  methods: {

    // 获取所有接口的汇总文档
    getAllApiDoc() {
      this.docDownloading = true;
      let fileName = '';
      let projectName = '';
      const lan = this.$cookies.get('portal.locale') || this.$cookies.get('browserLan');

    //获取项目信息
      try {
        getProjectInfo(lan).then(function(res){
      projectName = res.name;
        })
      } catch (error) {
         console.error(err);
      }

      try {
        getProductIdAndVersion()
          .then(function (res){
            fileName =  res.data + ' OpenAPI' + this.$t('document.developmentGuide');
          })
      } catch (err) {
        console.error(err);
      }
      fileName = projectName + ' ' + fileName;

      try {
        getAllApiDoc()
          .then(({ data }) => {
            try {
              downloadFile(data, fileName + '.docx');
              this.docDownloading = false
            } catch (err) {
              console.error(err);
              this.docDownloading = false
            }
          })
      } catch (err) {
        console.error(err);
      }
    },


    handleNodeClick(data) {
      let me = this;
      this.$router.push({ path: '/document/' + data.id });
    },
    showTree(data) {
      let me = this;
      let newData = [];
      data.forEach(function (item, index, arr) {
        if (!item.visible) {

        } else {
          newData.push(item);
          if (item.children) item.children = me.showTree(item.children);
        }
      });
      data = newData;
      return data;
    },
    findIntiTree(data) {
      let me = this;
      if (!data.hasChildren) {
        me.currentTreeId = data.id;
      } else {
        me.findIntiTree(data.children[0])
      }
    },
    findDocById() {
      let me = this;
      const param = {
        "id": me.docId
      }
      getTree(param).then(function (res) {
        if (res.data.code === '0') {
          let data = res.data.data;
          if (me.docId == 0) {
            me.findIntiTree(data.children[0]);
            me.docId = String(me.currentTreeId);
            me.findDocById();
            return false;
          }
          me.currentTreeId = me.docId;
          let treeary = data.treePath.split(',');
          treeary.forEach(function (item, idex) {
            me.expandedTree.push(item);
          })
          if (data.relatedGroupId) {
            me.isApiPage = true;
            let groupIds = [];
            groupIds.push(data.relatedGroupId);
            me.path.push({ "title": data.title, "id": data.id });
            let params = {
              pageNo: 1, //this.tablePage.pageNo,
              pageSize: 1000, //this.tablePage.pageSize,
              groupIds: groupIds || [], //this.filter.groupId,
              groupCascadeSearch: true
            };
            me.sdkId = groupIds[0] || '';
            let par = {
              id: data.relatedGroupId
            };
            getGroup(par).then(function (response) {
              if (response.data.code === '0') {
                let gDes = response.data.data.description;
                gDes = gDes.replace(/#API@/g, '【<a class=\"apitt\" href=\"javascript:void(0)\" >');
                gDes = gDes.replace(/#DOC@/g, '【<a class=\"docdd\" href=\"javascript:void(0)\" >');
                gDes = gDes.replace(/@#/g, '</a>】');
                gDes = gDes.replace(/&lt;/g, '<');
                gDes = gDes.replace(/&gt;/g, '>');
                me.groupDescription = gDes;
              } else {
                me.$message.error(me.$t(errorCodeKey(response.data.code)), me.$t('document.requestFail'));
              }
            }).catch(function () {
              me.$message.error(me.$t('document.requestFail'));
            })
            getApiByGroupId(params).then(function (response) {
              if (response.data.code === '0') {
                me.apis = me.initGroupApiData(response.data.data.list);
              } else {
                me.$message.error(me.$t(errorCodeKey(response.data.code)), me.$t('document.requestFail'));
              }
            }).catch(function (err) {
              me.$message.error(me.$t('document.requestFail'));
            }).then(function () {
              let herfid = me.$route.hash;
              if (herfid) {
                herfid = herfid.slice(1);
                const offsetdiv = document.getElementById(herfid);
                let hei = document.getElementById(herfid).offsetTop;
                document.documentElement.scrollTop = hei;
              } else {
                document.documentElement.scrollTop = 0;
              }

            })
          } else {

            me.isApiPage = false;
            let doid = {
              "id": data.id
            }
            me.map = '';
            getDocById(doid).then(function (response) {
              if (response.data.code === '0') {

                me.map = response.data.data;
                let htmlContentData = me.map.html || '';

                htmlContentData = htmlContentData.replace(/#API@/g, '【<a class=\"apitt\" href=\"javascript:void(0)\" >');
                htmlContentData = htmlContentData.replace(/#DOC@/g, '【<a class=\"docdd\" href=\"javascript:void(0)\" >');
                htmlContentData = htmlContentData.replace(/@#/g, '</a>】');
                htmlContentData = htmlContentData.replace(/&lt;/g, '<');
                htmlContentData = htmlContentData.replace(/&gt;/g, '>');
                me.map.html = htmlContentData;
              } else {
                me.$message.error(me.$t(errorCodeKey(response.data.code)), me.$t('document.requestFail'));
              }
            }).catch(function () {
              me.$message.error(error);
            }).then(function () {
              let docTag = document.getElementsByTagName('h2');
              me.docList = [];
              if (docTag.length) {
                for (let d = 0; d < docTag.length; d++) {

                  let dAdd = d + 1;
                  let dClassName = "doc" + dAdd;
                  let docc = {};
                  docc.title = docTag[d].innerText;
                  let ahtml = '<a :href="#' + docc.title + '" aria-hidden="true" class="header-anchor" style="display: none">#</a>';
                  docTag[d].innerHTML = ahtml + docTag[d].innerHTML;
                  docTag[d].id = dClassName;
                  docc.hrefId = '#' + dClassName;
                  me.docList.push(docc);
                }
              }
            })
          }
        } else {
          me.$message.error(error);
        }
      })


    },
    initGroupApiData(data) {

      const that = this;
      let newData = [];
      for (let t in data) {
        if (data[t].status == 'ONLINE') {
          newData.push(data[t]);
        }
      }
      data = newData;
      for (let i in data) {
        let apiData = JSON.stringify(data[i]) || '{}';
        apiData = apiData.replace(/#API@/g, '【<a class=\\"apitt\\" href=\\"javascript:void(0)\\">');
        apiData = apiData.replace(/#DOC@/g, '【<a class=\\"docdd\\" href=\\"javascript:void(0)\\">');
        apiData = apiData.replace(/@#/g, '</a>】');
        data[i] = JSON.parse(apiData);
        data[i].herfName = '#' + data[i].name;
        data[i].hrefId = '#' + data[i].id;
        let json = data[i].response.example || '{}';
        if (that.isJSON(json)) {
          json = json.replace(/(^\s*)|(\s*$)/g, "");
          // data[i].response.resDemo = JSON.stringify(JSON.parse(json.replace(/(^\s*)|(\s*$)/g, "")), null, 4);
          data[i].response.example = JSON.stringify(JSON.parse(json), null, 4);
        } else {
          data[i].response.example = '{}';
        }

        let inBody = null;
        let inParams = [];
        for (let j = 0; j < data[i].inputParams.length; j++) {
          let inParm = data[i].inputParams[j];
          if (inParm.position == 'Body') {
            inBody = inParm;
          } else {
            if (inParm.model) {
              //如果入参已经有model对象，那么重新修改model.children使其符合table数据格式
              for (let j = 0; j < inParm.model.children.length; j++) {
                inParm.model.children[j] = {
                  model: inParm.model.children[j]
                }
              }
            } else {
              //如果入参没有model对象，那么构造model对象
              inParm.model = {
                name: inParm.paramName || '',
                required: !inParm.nullable || false,
                type: inParm.paramType || 'String',
                description: inParm.description || '',
                children: []
              };
            }
            inParm.children = inParm.model.children;
            if (data[i].inputParams[j].displayInDocument) {
              inParams.push(inParm);
            }
          }
        }
        //排序 required为true排在前面，之后按首字母
        // inParams.sort((a, b)=>{
        //   return sortByRequiredAndLetter(a.model.required, b.model.required, a.model.name, b.model.name)
        // });
        function sortChildren(arr) {
          if (!arr || !arr.length) {
            return;
          }
          arr.sort((a, b) => {
            return sortByRequiredAndLetter(a.required, b.required, a.name, b.name)
          });
          arr.forEach((r) => {
            if (r.children) sortChildren(r.children);
          })
        }

        function sortByRequiredAndLetter(r1, r2, n1, n2) {
          n1 = n1.toUpperCase();
          n2 = n2.toUpperCase();
          r1 = Number(r1);
          r2 = Number(r2);
          if (r1 > r2) {
            return -1
          } else if (r1 < r2) {
            return 1
          } else {
            // if (n1 < n2) {
            //     return -1;
            // }
            // if (n1 > n2) {
            //     return 1;
            // }
            // return 0;
            return n1 > n2;
          }
        }

        /**
         * 将inParms数组的数据复制至用于显示table的_inParms数组里
         * 由于入参定义表格需要显示enum子节点而后端服务参数不需要，所以用两个数组显示表格数据
         */
        data[i].inputParams = tableData.init(inParams, true);

        if (inBody) {
          if (inBody.model) {
            let nArr = [];
            // for (let r = 0; r < inBody.model.children.length; r++) {
            //   if(inBody.model.children[r].displayInDocument){
            //     nArr.push(inBody.model.children[r])
            //   }
            // }
            inBody.model.children = realHidden(inBody.model.children);
            inBody.children = [inBody.model];
          } else {
            inBody.children = null;
          }

          //排序 required为true排在前面，之后按首字母
          // sortChildren(inBody.children);

          if (inBody.children && inBody.children.length > 0) {
            // tableData.addParent(inBody.children, inBody);
            inBody.children = tableData.init(inBody.children);
          }


          inBody.demo = inBody.example;
          inBody.contentType = data[i].contentType;
          data[i].inBody = inBody;

          try {
            data[i].inBody.example = JSON.stringify(JSON.parse(data[i].inBody.demo.replace(/(^\s*)|(\s*$)/g, "")), null, 4);
          } catch (error) {

          }
        }
        //返回结果
        const response = data[i].response;
        if (response) {
          if (response.model) {
            //model属性不是一个数组，所以为其构建一个children数组，并将model复制给children[0]，构建一个children循环数组
            response.children = [response.model];
            response.children = hideParam(response.children);
          } else {
            response.children = [];
          }

          //排序 required为true排在前面，之后按首字母
          // sortChildren(response.children);

          if (response.children && response.children.length > 0) {
            // tableData.addParent(response.children, response);
            response.children = tableData.init(response.children);
          }
        }

      }
      function hideParam(data) {
        let newArr = [];
        data.forEach(function (item, index, arr) {
          if (!item.displayInDocument) {

          } else {
            newArr.push(item);
            if (item.children) item.children = hideParam(item.children);
          }
        });
        data = newArr;
        return data;
      }
      function hiddenEmptyObject(data) {
        data.forEach(function (item, index, arr) {
          if (item.type == 'Object' || item.type == 'Array') {
            if (item.children.length > 0) {
              for (var i = 0; i < item.children.length; i++) {
                realHiddenObj(item.children);
              }
            } else {
              // data.splice(index, 1)

            }
          }
        });
      }
      function realHidden(data) {
        let newArr = hideParam(data);
        // hiddenEmptyObject(newArr);
        return newArr;
      }

      function realHiddenObj(data) {
        for (var j = 0; j < data.length; j++) {
          if (data[j].type != 'Object' && data[j].type != 'Array') {
            continue;
          } else if (data[j].children.length > 0) {
            realHiddenObj(data[j].children)
          } else {
            // data.splice(j,1)
            // j--;
          }
        }
      }

      return data;

    },
    apiJ: function (e) {
      const me = this;
      // const abpiBlock;
      if (e.target.className == 'apitt') {  //获取api
        const apiName = e.target.innerText;
        let params = {
          pageNo: 1, //this.tablePage.pageNo,
          pageSize: 1000, //this.tablePage.pageSize,
          apiName: apiName || '', //this.filter.apiName,
          groupCascadeSearch: true
        };
        getApiByGroupId(params).then(function (response) {
          if (response.data.code === '0') {
            let apiGroupId = response.data.data.list[0].group.id;
            let apiPid = response.data.data.list[0].group.parentId;
            let apigroupName = response.data.data.list[0].group.name;
            let apiId = response.data.data.list[0].id;
            me.isApiPage = true;
            let par = {
              id: apiGroupId,
            };
            getDocByGroupId(par).then(function (re) {
              if (re.data.code === '0') {
                let treeid = re.data.data.id;
                me.$router.push({ path: '/document/' + treeid + '#' + apiId });
              } else {
                me.$message.error(me.$t('document.requestFail'));
              }
            })
          } else {
            me.$message.error(me.$t(errorCodeKey(response.data.code)), me.$t('document.requestFail'));
          }
        }).catch(function () {
          me.$message.error(me.$t('document.requestFail'));
        })
      } else if (e.target.className == 'docdd') { //获取文档
        let docName = e.target.innerText;
        docName = docName.split('->');
        // let params = {
        //             pageNo: 1, //this.tablePage.pageNo,
        //             pageSize: 1000, //this.tablePage.pageSize,
        //             title: docName || ''
        //         };
        let params = docName;
        getDocByName(params).then(function (response) {
          if (response.data.code === '0') {
            // let docPid = response.data.data.list[0].parentId;
            let docid = response.data.data.id;
            me.$router.push({ path: '/document/' + docid });
            me.isApiPage = false;
          } else {
            me.$message.error(me.$t(errorCodeKey(response.data.code)), me.$t('document.requestFail'));
          }
        }).catch(function () {
          me.$message.error(me.$t('document.requestFail'));
        })
      }

    },
    isJSON(str) {
      if (typeof str == 'string') {
        try {
          var obj = JSON.parse(str);
          if (typeof obj == 'object' && obj) {
            return true;
          } else {
            return false;
          }
        } catch (e) {
          return false;
        }
      }
    },
    jumpToWeb(params) {
      var host = window.location.host;
      var protocol = window.location.protocol
      var port = window.location.port

      if (host.indexOf(":") != -1) {
        if (protocol == 'https:') {
          window.open(protocol + "//" + host + params)
        } else if (protocol == 'http:') {
          port = process.env.VUE_APP_ARTEMIS_WEB_PORT
          host = host.substring(0, host.indexOf(":"))
          window.open(protocol + "//" + host + ":" + port + params)
        }
      } else {
        window.open(protocol + "//" + host + params)
      }


    },
    getApiGroupDoc(param) {
      this.downloading = true
      try {
        getApiGroupDoc(param)
          .then(({ data }) => {
            try {
              downloadFile(data, this.path[this.path.length - 1]['title'] + '.docx');
              this.downloading = false
            } catch (err) {
              console.error(err);
              this.downloading = false
            }
          })
      } catch (err) {
        console.error(err);
      }

    },

    getSdkByApiGroupPId(param) {
      this.sdkDownloading = true
      var timestamp = Date.parse(new Date())
      try {
        getSdkByApiGroup(param)
          .then(({ data }) => {
            try {
              downloadFile(data, 'SDK_JAVA_' + this.path[this.path.length - 1]['title'] + '_' + timestamp + '.zip');
              this.sdkDownloading = false
            } catch (err) {
              console.error(err);
              this.sdkDownloading = false
            }
          })
      } catch (err) {
        console.error(err);
      }
    }
  },
  mounted() {
    const me = this;
    me.docId = me.$route.params.id;
    // me.docId = (String)me.$route.params.id;
    this.findDocById();
    getApiHost('{}').then(function (res) {
      if (res.data.code === '0') {
        me.hostPath = res.data.data;
      } else {
        me.$message.error(me.$t(errorCodeKey(res.data.code)), me.$t('document.requestFail'));
      }
    }).catch(function () {
      me.$message.error(me.$t('document.requestFail'));
    })
  },
  watch: {
    activeData(newactiveData, oldactiveData) {
      this.docId = (newactiveData.id + '') || this.$route.params.id;
      this.findDocById();
    },
    $route() {
      const me = this;
      if (me.docId != me.$route.params.id) {
        me.docId = me.$route.params.id;
        // me.docId = (String)me.$route.params.id;
        me.findDocById();
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import url(../assets/css/markdown.css);
.btn-p {
  margin-top: 5px;
}
pre {
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
}
.middleCon pre {
  width: 100%;
  max-height: 400px;
  overflow: auto;
}
.document.clearfix {
  height: 100%;
  width: 100%;
}
.middleCon {
  position: absolute;
  left: 256px;
  width: calc(100% - 455px);
  word-break: break-all;
  .no-data {
    margin: 0 auto;
    width: 240px;
    height: 160px;
    background: url(../assets/images/no_data.png) no-repeat center;
    background-size: 100%;
    & + .txt {
      font-size: 14px;
      text-align: center;
      color: rgba(0, 0, 0, 0.4);
    }
  }
}
.detailContent {
  padding: 17px;
  // width: 85%;
  // width: calc(100% - 455px)
}
.font14 {
  font-size: 14px;
}
.font15 {
  font-size: 15px;
}
h3, .font16{
  padding: 5px 0;
}
h1 , .font24 {
  font-size: 24px;
  padding-bottom: 10px;
}
.tableScroll.example-container {
  overflow: auto;
  word-break: break-all;
}
.apiPage p {
  line-height: 20px;
}
.showAnchor {
  position: fixed;
  z-index: 10;
  top: 78px;
  right: 40px;
  max-height: 80%;
  overflow: auto;
}
a.h-anchor-link__title {
  width: 170px;
}
// .markdown-wrapper.equal-height {
//     width: 100%;
// }
a.btn.download {
  text-decoration: none;
  color: white;
}
a.btn.downloadfile {
  text-decoration: none;
  color: white;
}
.javaDownBt {
  display: block;
  margin-left: 8px;
}
.downbt {
  position: absolute;
  // right: 15%;
  right: 20px;
  top: 15px;
}
.el-button + .el-button {
  margin-left: 8px;
  margin-top: 8px;
}
::-webkit-scrollbar {
  width: 7px;
  // height: 10px;
  /*background-color: #ddd;*/
}
/*滑块*/
::-webkit-scrollbar-thumb {
  background-color: rgba(157, 149, 149, 0.21176);
  border-radius: 20px;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #777;
}


/*滑道*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px white;
  border-radius: 20px;
}
a {
  text-decoration: none;
}
.debug-online-btn {
  border: 1px solid #31b4e1;
  padding: 4px 16px;
  border-radius: 2px;
  color: #31b4e1;
  &:hover {
    background-color: #31b4e1;
    color: #fff;
  }
}
// 点击调试 按钮样式
.markdown-wrapper .debug-online-btn {
  border: 1px solid #31b4e1;
  padding: 4px 16px;
  border-radius: 2px;
  color: #31b4e1;
}

.markdown-wrapper .debug-online-btn:hover {
  background-color: #31b4e1;
  color: #fff;
}

.el-table__footer-wrapper, .el-table__header-wrapper{
  overflow: auto;
}
.table-margin {
  padding: 15px 0;
}
a.header-anchor {
  display: none;
}
.el-tree-node.is-current {
  max-width: 95%;
  widows: 95%;
}

.header-right {
  margin-top: 30px;
  width: 100px;

  float: right;
}
.baseTitleStyle {
  margin-top: 10px;
  border-left: 3px solid #2395f1;
}
.baseLineTitleStyle {
  margin-left: 20px;
  margin-top: 10px;
  font-weight: bold;
  display:inline-block
}
.baseLineStyle {
  display:inline
}
</style>
<style lang="scss" >
.el-tree-node.is-current {
  max-width: 95%;
  widows: 95%;
}
</style>
